import {gsap} from "gsap";
import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';
import {smootherSetup, smoother} from '../Utility/scroll-smoother.js';

document.addEventListener( 'DOMContentLoaded', function() {
    const tlBlock = document.querySelector('.timeline');

    if( tlBlock ) {

        // mobile slider variables
        const mobileTimeline = document.querySelector('.timeline-popup-mobile');
        document.body.append( mobileTimeline );
        const timelineMobileSlider = document.querySelector('.timeline-popup-mobile__slider');

        // desktop slider variables
        const tl = tlBlock.querySelector('.timeline__timeline__wrapper__months');
        const tlWrapper = tlBlock.querySelector('.timeline__timeline__wrapper');
        const tlPhases = tlBlock.querySelectorAll('.phase a');
        const tlPopups = tlBlock.querySelectorAll('.timeline__timeline__popup');
        const illustrations = tlBlock.querySelectorAll('.phase-img');
        const body = document.body;

        if(tlPhases) {

            // horizontal dragging
            let isDown = false;
            let startX;
            let scrollLeft;

            tl.addEventListener('mousedown', (e) => {
                isDown = true;
                tl.classList.add('active');
                startX = e.pageX - tl.offsetLeft;
                scrollLeft = tl.scrollLeft;
            });
            tl.addEventListener('mouseleave', () => {
                isDown = false;
                tl.classList.remove('active');
            });
            tl.addEventListener('mouseup', () => {
                isDown = false;
                tl.classList.remove('active');
            });
            tl.addEventListener('mousemove', (e) => {
                if(!isDown) return;
                e.preventDefault();
                const x = e.pageX - tl.offsetLeft;
                const walk = (x - startX) * 0.8; // scroll speed
                tl.scrollLeft = scrollLeft - walk;
                console.log(walk);
            });
            // end horizontal dragging

            tlPhases.forEach(phase => {
                
                // click function to slide timeline and open popups
                phase.addEventListener('click', (item) => {
                    item.preventDefault();
                    item.stopPropagation();

                    // console.log(phase.firstChild);
                    
                    // active state for clicked phase
                    tlPhases.forEach(phase => {
                        phase.classList.remove('active');
                    });
                    phase.classList.add('active');

                    // disable overflow hidden on timeline
                    tl.classList.add('show');

                    // makes illustrations active/inactive
                    let clickedPhase = item.target.getAttribute('data-phase');
                    
                    if( illustrations ) {
                        illustrations.forEach(img => {
                            img.classList.remove('active');
            
                            if( img.getAttribute('data-phase') === clickedPhase ) {
                                img.classList.add('active');
                            }
            
                        });
                    }

                    // makes the clicked phases scroll to the middle of the screen
                    let tlHalfWrapWidth = tlWrapper.clientWidth/2;
                    let itemParent = item.target.parentElement;
                    let slideAmount = ((-1 * itemParent.offsetLeft) + (tlHalfWrapWidth - (itemParent.offsetWidth/2))) * 100 / tl.scrollWidth;
                        
                    const mediaQueryList = window.matchMedia('(max-width: 990px)');

                    if(mediaQueryList.matches) {
                        // mobile popup
                        openMobilePopup(clickedPhase);
                    }
                    else {

                        gsap.to(tl, {
                            xPercent: slideAmount,
                            scrollTrigger: {
                                trigger: item.target,
                                // start: "top top",
                            },
                        })

                        // opens popup desktop
                        openPhasePopup(item);
                    }

                });
            });

            // close btn for closing popups
            tlPopups.forEach(popup => {
                let closeBtn = popup.querySelector('.close-phase-popup');
                closeBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    closePhasePopup();
                });
            });
        }

        function openPhasePopup(item) {
            let activePopup = document.querySelector('.timeline__timeline__popup.active');
            let targetPopup = tlBlock.querySelector(item.target.getAttribute('data-target'));
            
            // closes active popup
            if( activePopup ) {
                activePopup.classList.remove('active');
            }
        
            // opens target popup
            setTimeout(function(){
                targetPopup.classList.add('active');
            }, 300);
        }
        
        function closePhasePopup() {
            let activePopup = document.querySelector('.timeline__timeline__popup.active');

            // closes active popup
            if( activePopup ) {
                activePopup.classList.remove('active');
            }

            // enable overflow hidden on timeline
            tl.classList.remove('show');

            if( tlPhases ) {
                tlPhases.forEach(phase => {
                    phase.classList.remove('active');
                });
            }
        
            // sets illustration state back to active
            if( illustrations ) {
                illustrations.forEach(img => {
                    img.classList.add('active');
                });
            }
        
            // moves timeline back to starting point
            gsap.to(tl, {
                xPercent: 0
            })
        }

        // mobile timeline popup
        function openMobilePopup(slideNumber) {
            
            body.style.top = `-${window.scrollY}px`;
            
            // prevents scroll on body 
            body.classList.add('scroll-lock');

            goToSlide = Number(slideNumber)-1;

            mobileSplide.go(goToSlide);
            
            // opens the mobile popup
            mobileTimeline.classList.add('active');
            
            mobileSplide.refresh();

            // disables scroll smoother
            // smoother.kill();
        }

        function closeMobilePopup(item) {
            
            const scrollY = body.style.top;
            body.classList.remove('scroll-lock');
            body.style.top = '';
            window.scrollTo(0, (parseInt(scrollY||'0')) * -1 );
            
            mobileTimeline.classList.remove('active');

            // remove active state for desktop phases
            if( tlPhases ) {
                tlPhases.forEach(phase => {
                    phase.classList.remove('active');
                });
            }

            // sets illustration state back to active
            if( illustrations ) {
                illustrations.forEach(img => {
                    img.classList.add('active');
                });
            }

            // enables scroll smoother
            smootherSetup();
            
            // moves timeline back to starting point
            const totalSlides = Number(item.currentTarget.getAttribute('data-total-slides'));
            const currentSlide = Number(item.currentTarget.getAttribute('data-current-slide'));
            
            if(totalSlides === currentSlide) {
                gsap.to(tl, {
                    xPercent: 0
                })
            }
        }

        if( timelineMobileSlider ) {
            var mobileSplide = new Splide( timelineMobileSlider , {
                type: 'slide',
                speed: 1000,
                perPage: 1,
                perMove: 1,
                arrows: false,
                snap: false,
                drag: false,
                pagination: false,
                autoHeight: false,
                rewind: true,
                waitForTransition: false,
            });

            // creates pagination out of timeline phases 
            mobileSplide.on( 'pagination:mounted', function ( data ) {
                // You can add your class to the UL element
                data.list.classList.add( 'timeline-popup-mobile__pagination' );
                
                // `items` contains all dot items
                data.items.forEach( function ( item ) {
                    let phaseLabel = timelineMobileSlider.querySelector('.mobile-phase-label-'+(item.page+1)).innerHTML;
                    item.button.textContent = String( phaseLabel );
                });
            });

            mobileSplide.mount();


            // close mobile popup
            const closePopupBtnMobile = timelineMobileSlider.querySelectorAll('.close-popup');
            
            closePopupBtnMobile.forEach((elem)=>{
                elem.addEventListener('click', (item) => {
                    closeMobilePopup(item);
                });
            });

        }
    }
});